const commonFn = {
  j2s(obj) {
    return JSON.stringify(obj)
  },
  shallowRefresh(name) {
    router.replace({ path: '/refresh', query: { name: name }})
  },
  shallowRefresh_(query) {
    router.replace({ path: '/refresh', query: query})
  },
  closeGlobalLoading() {
  },
  openGlobalLoading() {
  },
  cloneJson(obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  toastMsg(type, msg) {
    switch (type) {
      case 'normal':
        bus.$message(msg)
        break
      case 'success':
        bus.$notify.success({
          title: '成功',
          message: msg,
          offset: 100,
          showClose: false
        })
        // bus.$message({
        //   showClose: true,
        //   message: msg,
        //   type: 'success'
        // })
        break
      case 'warning':
        bus.$notify.warning({
          title: '警告',
          message: msg,
          offset: 100,
          showClose: false
        })
        // bus.$message({
        //   showClose: true,
        //   message: msg,
        //   type: 'warning'
        // })
        break
      case 'error':
        bus.$notify.error({
          title: '错误',
          message: msg,
          offset: 100,
          showClose: false
        })
        // bus.$message.error(msg)
        break
    }
  },
  clearVuex(cate) {
  },
  getHasRule(val) {
    const moduleRule = 'admin'
    let userInfo = Lockr.get('userInfo')
    if (userInfo.id == 1) {
      return true
    } else {
      let authList = moduleRule + Lockr.get('authList')
      return _.includes(authList, val)
    }
  }
}

export default commonFn



// WEBPACK FOOTER //
// ./src/global.js